module.exports = __webpack_public_path__ + "img/134.55b7d161.svg";